import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setFilterCount } from "web/redux/ducks/feed-sidebar";

/**
 * Keeps the number in the filter button up to date
 */
export function useFilterCountHandler(selectedFilters: number): void {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setFilterCount(selectedFilters));
    }, [dispatch, selectedFilters]);
}
